import {useEffect} from 'react';
import Button from 'Components/FormComponents/Button';
import {ReactComponent as CloseIcon} from 'assets/icons/close.svg';

const Modal = ({setIsOpen, modalContent, contentClasses}) => {

  useEffect(() => {
    if (setIsOpen) {
      document.body.classList.add('modal-opened');
      document.documentElement.classList.add('modal-opened');
    }

    const closeModalOnESC = (event) => {
      if (event.keyCode === 27) {
        document.documentElement.classList.remove('modal-opened');
        document.body.classList.remove('modal-opened');

        setIsOpen(false);
      }
    };

    document.addEventListener('keyup', closeModalOnESC);
    return () => {
      document.removeEventListener('keyup', closeModalOnESC);
    }
  }, [setIsOpen]);

  return (
    <>
      <div className="modal flex py-48 lg:p-48 fixed inset-0 bg-black items-center justify-center">
        <Button
          buttonClasses="button js-modal-close button--clear modal__close-button"
          onClick={() => {
            document.documentElement.classList.remove('modal-opened');
            document.body.classList.remove('modal-opened');

            setIsOpen(false);
          }}>
          <CloseIcon/>
        </Button>

        <div className={`modal-content p-15 ${contentClasses ? contentClasses : ''}`}>
          {/* Here modal content. */}
          {modalContent}
        </div>
      </div>
    </>
  );
};

export default Modal;
